// Public snapshot of the impact metrics, pulled from the production database
// (equip-locations-finder) on 2026-10-14. Refresh by re-running the same
// aggregates as analytics.impactMetrics against prod and pasting the counts here.
import type { ImpactMetricsData } from "./flowData";

/**
 * Frozen, presentation-ready figures for the public "How it works" page.
 * These mirror the live in-app numbers as of the snapshot date above.
 */
export const STATIC_IMPACT_METRICS: ImpactMetricsData = {
  // Discovery funnel
  totalLocations: 11_437,
  autoRejectedCount: 7_124,
  autoRejectionRate: 7_124 / 11_437, // ≈ 0.6229
  passedToReviewCount: 623,
  // Coverage & scale
  collectionsCount: 60,
  scansCount: 32,
  distinctSportTypes: 20, // across all 1_687 sport_courts rows (paginated past the 1_000-row cap)
  // Physical mapping output
  locationsMapped: 290,
  pilsPlaced: 944,
  photosCaptured: 4_359, // pil_photos (2_247) + location_mapping_photos (2_112)
  // Validation & delivery
  mainStations: 359,
  backupStations: 89,
  cityReviewedCount: 271,
  exportedToProd: 6, // manually confirmed; the pushed_to_prod flag is unreliable in prod
};
